export default __webpack_public_path__ + "static/media/midas.698351bb.jpeg";